/* eslint-disable  no-unused-vars */
export enum DVACardType {
  GOLD='gold',
  WHITE='white',
  LILAC='lilac',
  ORANGE='orange',
  BLUE='blue',
}
